import React from "react";
import { Mic } from "lucide-react";
import { useVoiceInput } from "./useVoiceInput";

const VoiceInput = ({ name, value, onChange, placeholder, required }) => {
  const { startListening } = useVoiceInput((text) => {
    onChange({ target: { name, value: text } });
  });

  return (
    <div className="relative">
      <input
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className="w-full border rounded px-3 py-3 text-sm pr-12 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <button
        type="button"
        onClick={startListening}
        className="absolute right-2 top-1/2 -translate-y-1/2 bg-blue-100 p-2 rounded-full"
      >
        <Mic size={18} className="text-blue-600" />
      </button>
    </div>
  );
};

export default VoiceInput;
